import React, { Component } from "react";
import { Breadcrumb } from "react-bootstrap";
import { connect } from "react-redux";
import Moment from "react-moment";
import Spinner from "react-bootstrap/Spinner";

class printRequest extends Component {
  constructor(props) {
    super(props);
    let encryptedId = this.props.location.search;
    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(
      encryptedId.replace("?p=", ""),
      process.env.REACT_APP_ENCRYPT_PASSWORD
    );
    var Referenceno = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.state = {
      referenceNo: Referenceno,
      loading: "",
      requesterId: 0,
      typeOfExit: 0,
      dateJoined: "",
      lastDayofService: "",
      phoneNumber: "",
      address: "",
      actionCategory: "",
      companycode: "",
      companyName: "",
      divisionName: "",
      divisioncode: "",
      actionType: 0,
      employeeId: "",
      employeeName: "",
      eDocType: "",
      startDate: "",
      endDate: "",
      positionId: "",
      salaryGrade: "",
      workingGroup: "",
      additionalInformation: "",
      description: "",
      userId: "",
      section: "",
      division: "",
      department: "",
      designation: "",
      requesterName: "",
      getApproverListArray: [],
      getApproverListArray: [],
      getWorkFlowListArray: [],
      loading: "",
      referenceLinkList: [
        {
          reflink: "",
          remarks: "",
        },
      ],
      attachmentList: [
        {
          referenceNo: "",
          filename: "",
          filetype: "",
          remarks: "",
          userId: 0,
        },
      ],
    };
  }

  componentDidMount() {
    this.setState({ loading: "Yes" });
    this.props.dispatch({ type: "headerTitle", value: "" });
    this.geteDocRequest();
    this.getWorkFlowList();
    this.getApproverList();
  }

  getApproverList = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetApprovers?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ getApproverListArray: data.resultObject });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  getWorkFlowList = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetWorkFlowHistory?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ getWorkFlowListArray: data.resultObject });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  geteDocRequest = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/eDocDetails?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (data.resultObject) {
              this.setState({
                referenceNo: data.resultObject.referenceNo,
                requesterId: data.resultObject.requesterId,
                typeOfExit: data.resultObject.typeOfExitName,
                dateJoined: data.resultObject.dateJoined,
                lastDayofService: data.resultObject.lastDayofService,
                phoneNumber: data.resultObject.phoneNumber,
                address: data.resultObject.address,
                actionCategory: data.resultObject.actionCategory,
                companycode: data.resultObject.companycode,
                companyName: data.resultObject.companyName,
                divisionName: data.resultObject.divisionName,
                divisioncode: data.resultObject.divisioncode,
                actionType: data.resultObject.actionTypeName,
                employeeId: data.resultObject.employeeId,
                eDocType: data.resultObject.eDocType,
                employeeName: data.resultObject.employeeName,
                startDate: data.resultObject.startDate,
                endDate: data.resultObject.endDate,
                positionId: data.resultObject.positionId,
                salaryGrade: data.resultObject.salaryGrade,
                workingGroup: data.resultObject.workingGroup,
                additionalInformation: data.resultObject.additionalInformation,
                description: data.resultObject.description,
                userId: data.resultObject.userId,
                referenceLinkList: data.resultObject.referenceLinkList,
                attachmentList: data.resultObject.attachmentList,
                requesterName:
                  data.resultObject.requesterId +
                  " - " +
                  data.resultObject.requesterName,
                section: data.resultObject.section,
                department: data.resultObject.department,
                division: data.resultObject.division,
                designation: data.resultObject.designation,
                loading: "",
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  printOrder = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setTimeout(() => {
      window.print();
    }, 1500);
  };
  cancelPrint = () => {
    window.location = process.env.REACT_APP_ENV + "/mytask/pending/list";
  };

  render() {
    if (this.state.loading) {
      return (
        <>
          <div className="content-area">
            <section>
              <div style={{ margin: "auto", width: "0%" }}>
                <Spinner animation="border" variant="primary" />
              </div>
            </section>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="content-area">
            <div className="row mb-2">
              <div className="col-md-10">
                Reference No. : {this.state.referenceNo}
              </div>
            </div>
            <section>
              <h2 className="form-heading">Requester Information</h2>
              <div className="form-group row mb-0">
                <label for="" className="col-sm-2 col-form-label">
                  {" "}
                  Staff No / Name{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <b>
                        {" "}
                        <span className="d-none d-sm-inline"> : </span>{" "}
                        {this.state.requesterName}{" "}
                      </b>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label for="" className="col-sm-2 col-form-label">
                  {" "}
                  Section
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <b>
                        {" "}
                        <span className="d-none d-sm-inline"> : </span>{" "}
                        {this.state.section}{" "}
                      </b>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label for="" className="col-sm-2 col-form-label">
                  {" "}
                  Department{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <b>
                        {" "}
                        <span className="d-none d-sm-inline"> : </span>{" "}
                        {this.state.department}{" "}
                      </b>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label for="" className="col-sm-2 col-form-label">
                  {" "}
                  Division{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <b>
                        {" "}
                        <span className="d-none d-sm-inline"> : </span>{" "}
                        {this.state.division}{" "}
                      </b>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label for="" className="col-sm-2 col-form-label">
                  {" "}
                  Designation{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <b>
                        {" "}
                        <span className="d-none d-sm-inline"> : </span>{" "}
                        {this.state.designation}{" "}
                      </b>{" "}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <h2 className="form-heading"> Requisition Details </h2>
              {this.state.eDocType?.includes("Employee Clearance") && (
                <div>
                  <div className="form-group row mb-0">
                    <label for="" className="col-sm-2 col-form-label">
                      {" "}
                      eDoc Type{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <b>
                            {" "}
                            <span className="d-none d-sm-inline"> : </span>{" "}
                            {this.state.eDocType}{" "}
                          </b>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label for="" className="col-sm-2 col-form-label">
                      {" "}
                      Type of Exit{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <b>
                            {" "}
                            <span className="d-none d-sm-inline"> : </span>{" "}
                            {this.state.typeOfExit}{" "}
                          </b>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label for="" className="col-sm-2 col-form-label">
                      {" "}
                      Date of Joined{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <b>
                            {" "}
                            <span className="d-none d-sm-inline"> : </span>{" "}
                            {this.state.dateJoined && (
                              <Moment format="DD-MM-YYYY">
                                {this.state.dateJoined}
                              </Moment>
                            )}{" "}
                          </b>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label for="" className="col-sm-2 col-form-label">
                      {" "}
                      Last Day of Service{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <b>
                            {" "}
                            <span className="d-none d-sm-inline"> : </span>{" "}
                            <Moment format="DD-MM-YYYY">
                              {this.state.lastDayofService}
                            </Moment>
                          </b>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label for="" className="col-sm-2 col-form-label">
                      {" "}
                      Phone Number{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <b>
                            {" "}
                            <span className="d-none d-sm-inline"> : </span>{" "}
                            {this.state.phoneNumber}{" "}
                          </b>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label for="" className="col-sm-2 col-form-label">
                      {" "}
                      Address{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <b>
                            {" "}
                            <span className="d-none d-sm-inline"> : </span>{" "}
                            {this.state.address}{" "}
                          </b>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label for="" className="col-sm-2 col-form-label">
                      {" "}
                      Description{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="d-flex align-items-baseline">
                        <p className="">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                          </>{" "}
                        </p>
                        <p
                          className="mytask-reference-text"
                          style={{ marginLeft: 5, marginTop: 9 }}
                          dangerouslySetInnerHTML={{
                            __html: this.state.description,
                          }}></p>
                      </div>
                    </div>
                    {/* <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <b>
                            {" "}
                            <span className="d-none d-sm-inline"> : </span>{" "}
                            {this.state.description}{" "}
                          </b>{" "}
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Single" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.eDocType}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.actionCategory}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Company Code
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.companyName}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Division Code{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.divisionName}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        EmployeeId / Name{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.employeeName}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Position ID{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.positionId}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Salary Grade{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.salaryGrade}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Working Group{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.workingGroup}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Addtional Information{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.additionalInformation}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Start Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.startDate && (
                                <Moment format="DD-MM-YYYY">
                                  {this.state.startDate}
                                </Moment>
                              )}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        End Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.endDate && (
                                <Moment format="DD-MM-YYYY">
                                  {this.state.endDate}
                                </Moment>
                              )}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                            style={{ marginLeft: 5, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.description}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Group" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.eDocType}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.actionCategory}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.actionType}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "None" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.eDocType}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.actionCategory}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.actionType}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Others{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.additionalInformation}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType != "HRIS" &&
                !this.state.eDocType?.includes("Employee Clearance") && (
                  <div>
                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.eDocType}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                            style={{ marginLeft: 5, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <b>
                              {" "}
                              <span className="d-none d-sm-inline">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {this.state.description}{" "}
                            </b>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
            </section>
            <section>
              <h2 className="form-heading"> Workflow History </h2>
              <div className="table-responsive custom-table-1">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: "150px" }}>
                        {" "}
                        Date{" "}
                      </th>
                      <th scope="col" style={{ width: "300px" }}>
                        {" "}
                        Workflow{" "}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.getWorkFlowListArray?.map((loopdata) => (
                      <tr>
                        <td>
                          {" "}
                          <Moment format="DD-MM-YYYY hh:mm:ss A">
                            {loopdata.createddate}
                          </Moment>{" "}
                        </td>
                        <td> {loopdata.description} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            <section>
              <h2 className="form-heading"> Approver Comments </h2>
              <div className="table-responsive custom-table-1">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: "150px" }}>
                        {" "}
                        Approver{" "}
                      </th>
                      <th scope="col" style={{ width: "300px" }}>
                        {" "}
                        Comments{" "}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.getApproverListArray.map((loopdata) => (
                      <tr>
                        <td>
                          {" "}
                          {loopdata.oriapproverid}/{loopdata.oriapprovername}{" "}
                        </td>
                        <td> {loopdata.comments} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            <div className="clearfix text-right standard-print">
              <button
                type="button"
                className="btn btn-cancel"
                data-dismiss="modal"
                onClick={() => this.cancelPrint()}>
                Cancel{" "}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.printOrder()}>
                {" "}
                Print{" "}
              </button>
            </div>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(printRequest);
